import { useContext } from 'react';
import { FiltersContext } from '../FiltersContext';
import { IOrderFilters } from '../useOrders';

interface IUseFilterTags {
  isFilterTypeValid: (key: string, value: string) => boolean;
  searchField: string;
  clearSearchField: () => void;
}

export const useFiltersTags = ({ isFilterTypeValid, searchField, clearSearchField }: IUseFilterTags) => {
  const { setFilters, filterCheckboxes, setFiltersCheckboxes, filterTags, setFilterTags } = useContext(FiltersContext);

  const handleClickFilterCheckbox = (i: number) => {
    const filterKey = filterTags[i].key;
    const filterValue = searchField;

    if (isFilterTypeValid(filterKey, filterValue)) {
      setFiltersCheckboxes(
        filterCheckboxes.map((coluna, index) => {
          return index === i ? { ...coluna, value: !coluna.value } : coluna;
        })
      );

      setFilterTags((prev) =>
        prev.map((coluna, index) => {
          const value = !coluna.value ? searchField : '';
          return index === i ? { ...coluna, value } : coluna;
        })
      );
    }
  };

  const removeFilterTag = (index: number) => {
    const uncheckedFilterTag = filterTags[index].filterName;
    if (uncheckedFilterTag === 'date') {
      return setFilters((prev) => ({
        ...prev,
        initialIssueDate: undefined,
        finalIssueDate: undefined,
        initialScheduleDate: undefined,
        finalScheduleDate: undefined
      }));
    }

    if (uncheckedFilterTag === 'purchaseOrderId') {
      clearSearchField();
    }

    setFilters((prev) => ({ ...prev, [uncheckedFilterTag]: undefined }));
  };

  const handleClearFilterTag = (i: number) => {
    setFilterTags((prev) => prev.map((coluna, index) => (index === i ? { ...coluna, value: '' } : coluna)));

    setFiltersCheckboxes(
      filterCheckboxes.map((coluna, index) => {
        return index === i ? { ...coluna, value: false } : coluna;
      })
    );

    removeFilterTag(i);
  };

  const getBranchId = (branch: string) => branch.split(' - ')[0];

  const getFilterTags = (): IOrderFilters => {
    const filters = filterTags
      .filter((tag) => tag.value !== '' && tag.filterName !== 'date')
      .map((tag) => {
        if (tag.filterName === 'branchId') {
          return {
            [tag.filterName]: getBranchId(tag.value)
          };
        }

        return {
          [tag.filterName]: tag.value
        };
      });

    return Object.assign({}, ...filters);
  };

  const clearFilterTags = () => {
    setFilterTags((prev) => prev.map((item) => (item.filterName === 'date' ? item : { ...item, value: '' })));
    setFiltersCheckboxes(filterCheckboxes.map((item) => ({ ...item, value: false })));
  };

  return {
    filterCheckboxes,
    setFiltersCheckboxes,
    filterTags,
    setFilterTags,
    handleClickFilterCheckbox,
    handleClearFilterTag,
    getFilterTags,
    clearFilterTags
  };
};
